import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Checkbox from '@material-ui/core/Checkbox';
import { CircularProgress, MenuItem } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import OrderDetails from "./OrderDetails";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    loadingStyle: {
        marginLeft: '220px',
        marginTop: '220px'
    }
}));

function LocalDeliveryManagement(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('localDelivery');

    const [orders, setOrders] = useState([]);
    const [isChecked, setIsChecked] = useState([]);
    const [loading, setLoading] = useState(true);

    const toggleCheckboxValue = (index) => {
        setIsChecked(isChecked.map((v, i) => (i === index ? !v : v)));
    }

    useEffect(() => {
        if(props.orders) {
            if(props.orders.length > 0) {
                setOrders(props.orders);
                setIsChecked(props.orders.slice().fill(false));
            }
            props.clearAllChecked(false);
        }
    }, [props.orders])
    useEffect(() => {
        if(props.isChecked) {
            setIsChecked(props.isChecked);
        } else {
            setIsChecked([]);
        }
    }, [props.isChecked])
    useEffect(() => {
        if(props.loading) {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [props.loading])
    useEffect(() => {
        if(isChecked) {
            if(isChecked.length > 0) {
                let checkedOrdersCurr = [];
                isChecked.map((checked, index) => {
                    if(checked) {
                        checkedOrdersCurr.push(orders[index].order_id);
                    }
                })
                props.handleCheckedOrders(checkedOrdersCurr);
            }
        }
    }, [isChecked])

    return (
        <Fragment>
            {
                loading &&
                <div className={classes.loadingStyle}>
                    <CircularProgress color='secondary'/>
                </div>
            }
            <div>
            {
                !loading && 
                isChecked.length === orders.length && 
                orders.length > 0 &&
                orders.map((order, index) => (
                    <MenuItem value={order.order_id} key={index}>
                        <Checkbox 
                            key={index} 
                            checked={isChecked[index]}
                            onClick={() => toggleCheckboxValue(index)}
                        ></Checkbox>
                        <OrderDetails key={order.order_id}order={order}/>
                    </MenuItem>
                ))
            }
            </div>
        </Fragment>
    )
}

export default LocalDeliveryManagement;